import React, { Component } from "react";
import RoomAPI from "../../api/room";
import Ceilings from "./decorations/ceilings";
import Walls from "./decorations/walls";
import Floors from "./decorations/floors";
import Decorations from "./decorations/decorations";
import DecorationsSubMenu from "./decorations/mobile/decorationsSubMenu";
import MobileDecorations from "./decorations/mobile/decorations";
import MobileWalls from "./decorations/mobile/walls";
import MobileFloors from "./decorations/mobile/floors";
import MobileCeilings from "./decorations/mobile/ceilings";

export default class RoomDecorations extends Component {
  state = {
    mobileActive: false,
    activeSection: "decorations",
    activeDecorationType: "",
    decorationsLoading: true,
    decorations: {},
    walls: [],
    colors: [],
    floors: [],
    ceilings: [],

    mobileMenuActive: false,
  };

  handleManualScroll = (direction) => {
    switch (direction) {
      case "right":
        try {
          document.getElementById("partsSlider").scrollLeft -= 120;
        } catch (error) {
          return;
        }
        break;
      default:
        try {
          document.getElementById("partsSlider").scrollLeft += 120;
        } catch (error) {
          return;
        }
        break;
    }

    // this.handleScroll();
  };

  loadDecorations = () => {
    const api = new RoomAPI();
    api.getParts().then((response) => {
      if (response.success) {
        this.setState({ ...this.state, ...response.data });
        const decorationKeys = Object.keys(response.data.decorations);
        if (decorationKeys.length > 0) {
          this.setState({
            activeDecorationType: decorationKeys[0],
          });
        }
      }
      this.setState({ decorationsLoading: false });
    });
  };

  componentDidMount() {
    this.loadDecorations();
  }

  activeSectionHandler = (section) => {
    // if (section === this.state.activeSection) {
    //   this.setState({ activeSection: "" });
    //   return;
    // }
    this.setState({ activeSection: section });
  };

  activeDecorationTypeHandler = (evt) => {
    evt.preventDefault();
    const decorationType = evt.target.id;
    // to avoid closing tab while reciving click event on child
    if (!decorationType || decorationType.length < 2) {
      return;
    }
    if (decorationType === this.state.activeDecorationType) {
      this.setState({ activeDecorationType: "" });
      return;
    }
    this.setState({ activeDecorationType: decorationType });
  };

  render() {
    return (
      <div>
        {/* Mobile version */}
        <div
          className={`mobile-menu-right-side ${
            this.state.mobileActive ? "active" : ""
          }`}
        >
          <button
            className="w-100 carpet-btn"
            onClick={() =>
              this.setState({ mobileActive: !this.state.mobileActive })
            }
          >
            {this.props.texts["decoration"]}
          </button>
          <div className="d-flex">
            <div className="list-body">
              <ul className="pt-4">
                <li
                  className={`first-child ${
                    this.state.activeSection === "decorations" ? "active" : ""
                  }`}
                  onClick={() => this.activeSectionHandler("decorations")}
                >
                  <span>
                    <i className="arrow" /> {this.props.texts["room_services"]}{" "}
                  </span>
                </li>
                {this.state.activeSection === "decorations" && (
                  <DecorationsSubMenu
                    decorations={this.state.decorations}
                    activeDecorationTypeHandler={
                      this.activeDecorationTypeHandler
                    }
                  />
                )}
                <li
                  className={`first-child ${
                    this.state.activeSection === "floors" ? "active" : ""
                  }`}
                  onClick={() => this.activeSectionHandler("floors")}
                >
                  <span>
                    <i className="arrow" /> {this.props.texts["floor_covering"]}{" "}
                  </span>
                </li>
                <li
                  className={`first-child ${
                    this.state.activeSection === "walls" ? "active" : ""
                  }`}
                  onClick={() => this.activeSectionHandler("walls")}
                >
                  <span>
                    <i className="arrow" /> {this.props.texts["wall"]}{" "}
                  </span>
                </li>
                <li
                  className={`first-child ${
                    this.state.activeSection === "ceilings" ? "active" : ""
                  }`}
                  onClick={() => this.activeSectionHandler("ceilings")}
                >
                  <span>
                    <i className="arrow" /> {this.props.texts["roof"]}{" "}
                  </span>
                </li>
              </ul>
            </div>

            <div className="carpet-body">
              {/* <ul className="upload-list-mobile active">
                <li>
                  <img src="/static/w3.jpg" alt="upload-img" />
                  <span className="close-icon" />
                </li>
                <li>
                  <img src="/static/w3.jpg" alt="upload-img" />
                  <span className="close-icon" />
                </li>
                <li>
                  <img src="/static/w3.jpg" alt="upload-img" />
                  <span className="close-icon" />
                </li>
                <li>
                  <img src="/static/w3.jpg" alt="upload-img" />
                  <span className="close-icon" />
                </li>
              </ul> */}
              <div className="last-child">
                {/* inja mituni az component Ceilings , Walls , Floors estefade koni ke sakhtareshun mesle zire */}
                {this.state.activeSection === "decorations" && (
                  <MobileDecorations
                    decorations={this.state.decorations}
                    selected={this.props.selectedDecorations}
                    scrollHandler={this.handleManualScroll}
                    selectHandler={this.props.decorationsSelectHandler}
                    activeDecorationType={this.state.activeDecorationType}
                    activeDecorationTypeHandler={
                      this.activeDecorationTypeHandler
                    }
                  />
                )}

                {this.state.activeSection === "walls" && (
                  <MobileWalls
                    walls={this.state.walls}
                    scrollHandler={this.handleManualScroll}
                    selectHandler={this.props.roomPartsSelectHandler}
                    selectedWall={this.props.selectedWall}
                    customSelectHandler={
                      this.props.decorationsCustomSelectHandler
                    }
					removeHandler={this.props.customDecorationsRemoveHandler}
					texts={this.props.texts}
                  />
                )}
                {this.state.activeSection === "floors" && (
                  <MobileFloors
                    floors={this.state.floors}
                    scrollHandler={this.handleManualScroll}
                    selectHandler={this.props.roomPartsSelectHandler}
                    selectedFloor={this.props.selectedFloor}
                    customSelectHandler={
                      this.props.decorationsCustomSelectHandler
                    }
					removeHandler={this.props.customDecorationsRemoveHandler}
					texts={this.props.texts}
                  />
                )}
                {this.state.activeSection === "ceilings" && (
                  <MobileCeilings
                    ceilings={this.state.ceilings}
                    scrollHandler={this.handleManualScroll}
                    selectHandler={this.props.roomPartsSelectHandler}
                    selectedCeiling={this.props.selectedCeiling}
                    customSelectHandler={
                      this.props.decorationsCustomSelectHandler
                    }
					removeHandler={this.props.customDecorationsRemoveHandler}
					texts={this.props.texts}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Mobile version */}

        <div className="right-sidebar-body">
          <ul className="nav-ul">
            <li
              className={
                this.state.activeSection === "decorations" ? "active" : ""
              }
              onClick={() => this.activeSectionHandler("decorations")}
            >
              {" "}
              {this.props.texts["room_services"]}
              <span>
                <i className="arrow" />
              </span>
            </li>
            <li
              className={this.state.activeSection === "floors" ? "active" : ""}
              onClick={() => this.activeSectionHandler("floors")}
            >
              {" "}
              {this.props.texts["floor_covering"]}
              <span>
                <i className="arrow" />
              </span>
            </li>
            <li
              className={this.state.activeSection === "walls" ? "active" : ""}
              onClick={() => this.activeSectionHandler("walls")}
            >
              {" "}
              {this.props.texts["wall"]}
              <span>
                <i className="arrow" />
              </span>
            </li>
            <li
              className={
                this.state.activeSection === "ceilings" ? "active" : ""
              }
              onClick={() => this.activeSectionHandler("ceilings")}
            >
              {" "}
              {this.props.texts["roof"]}
              <span>
                <i className="arrow" />
              </span>
            </li>
          </ul>
          {this.state.activeSection === "decorations" && (
            <Decorations
              decorations={this.state.decorations}
              selected={this.props.selectedDecorations}
              scrollHandler={this.handleManualScroll}
              selectHandler={this.props.decorationsSelectHandler}
              activeDecorationType={this.state.activeDecorationType}
              activeDecorationTypeHandler={this.activeDecorationTypeHandler}
              removeHandler={this.props.customDecorationsRemoveHandler}
            />
          )}
          {this.state.activeSection === "ceilings" && (
            <Ceilings
              ceilings={this.state.ceilings}
              scrollHandler={this.handleManualScroll}
              selectHandler={this.props.roomPartsSelectHandler}
              selectedCeiling={this.props.selectedCeiling}
              customSelectHandler={this.props.decorationsCustomSelectHandler}
			  removeHandler={this.props.customDecorationsRemoveHandler}
			  texts={this.props.texts}
            />
          )}
          {this.state.activeSection === "walls" && (
            <Walls
              walls={this.state.walls}
              scrollHandler={this.handleManualScroll}
              selectHandler={this.props.roomPartsSelectHandler}
              selectedWall={this.props.selectedWall}
              customSelectHandler={this.props.decorationsCustomSelectHandler}
			  removeHandler={this.props.customDecorationsRemoveHandler}
			  texts={this.props.texts}
            />
          )}
          {this.state.activeSection === "floors" && (
            <Floors
              floors={this.state.floors}
              scrollHandler={this.handleManualScroll}
              selectHandler={this.props.roomPartsSelectHandler}
              selectedFloor={this.props.selectedFloor}
              customSelectHandler={this.props.decorationsCustomSelectHandler}
			  removeHandler={this.props.customDecorationsRemoveHandler}
			  texts={this.props.texts}
            />
          )}

          {/* <div className="last-child">
            <div className="relative">
              <button
                name="scroll-right"
                className="m-0 button-shadow-right scroll"
                onClick={() => {
                  this.handleManualScroll("right");
                }}
              >
                <svg
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 240.823 240.823"
                  enableBackground="new 0 0 240.823 240.823"
                >
                  <g>
                    <path
                      id="Chevron_Right_1_"
                      d="M183.189,111.816L74.892,3.555c-4.752-4.74-12.451-4.74-17.215,0c-4.752,4.74-4.752,12.439,0,17.179
                                        l99.707,99.671l-99.695,99.671c-4.752,4.74-4.752,12.439,0,17.191c4.752,4.74,12.463,4.74,17.215,0l108.297-108.261
                                        C187.881,124.315,187.881,116.495,183.189,111.816z"
                    />
                  </g>
                </svg>
              </button>
              <ul>
                <li>
                  {" "}
                  <img src="/static/b7.png" alt="cover" />{" "}
                </li>
                <li>
                  {" "}
                  <img src="/static/Untitled-38.png" alt="cover" />{" "}
                </li>
                <li>
                  {" "}
                  <img src="/static/l34.png" alt="cover" />{" "}
                </li>
              </ul>
              <button
                name="scroll-left"
                className="m-0 button-shadow-left scroll"
                onClick={() => {
                  this.handleManualScroll("left");
                }}
              >
                <svg
                  version="1.1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 240.823 240.823"
                  enableBackground="new 0 0 240.823 240.823"
                >
                  <g>
                    <path
                      id="Chevron_Right"
                      d="M57.633,129.007L165.93,237.268c4.752,4.74,12.451,4.74,17.215,0c4.752-4.74,4.752-12.439,0-17.179
                                        l-99.707-99.671l99.695-99.671c4.752-4.74,4.752-12.439,0-17.191c-4.752-4.74-12.463-4.74-17.215,0L57.621,111.816
                                        C52.942,116.507,52.942,124.327,57.633,129.007z"
                    />
                  </g>
                </svg>
              </button>
            </div>

            <button className="upload-btn">
              <span>آپلود مستقیم</span>
            </button>
          </div> */}
          {/* below div for after image uploading */}
          {/* <div className="upload-img">
            <img src="/static/w3.jpg" alt="upload-img" />
            <span className="close-icon" />
            <div className="clear-both" />
            <button className="sec-upload-btn">بارگذازی</button>
          </div> */}
        </div>
      </div>
    );
  }
}
